import styled from 'styled-components'

export const IconLocal = styled.img`
  
`